import { BRANDS, COMPANY } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { Wrench, Zap, ShieldCheck, RefreshCcw, Phone } from "lucide-react";
import { onCallClick } from "@/lib/dialer";

export default function Brands() {
  const { t } = useLang();
  const tags = [
    { icon: Wrench, label: "Repair Services" },
    { icon: Zap, label: "Installation Services" },
    { icon: ShieldCheck, label: "Maintenance Services" },
    { icon: RefreshCcw, label: "Replacement Services" },
  ];
  return (
    <section id="brands" className="section-pad" data-testid="brands">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="text-xs font-bold uppercase tracking-[0.22em] text-ice-400">All Major HVAC Brands</div>
        <h2 className="mt-3 font-display text-3xl md:text-5xl font-black max-w-3xl">{t("brands.title")}</h2>
        <p className="mt-3 text-silver-300 max-w-2xl">
          We install, repair & service every major HVAC brand. Already have a system from another manufacturer? AIR-COLD HVAC can service it.
        </p>

        <div className="mt-8 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-3">
          {BRANDS.map((b, i) => (
            <div key={b} className="rounded-2xl bg-ink-800 ring-1 ring-white/10 px-4 py-5 grid place-items-center text-center hover:ring-ice-400/40 transition" data-testid={`brand-${i}`}>
              <span className="font-display font-bold text-base tracking-wide text-silver-300">{b}</span>
            </div>
          ))}
        </div>

        <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-3">
          {tags.map(({icon: Icon, label}, i) => (
            <div key={i} className="rounded-2xl bg-ink-800/70 ring-1 ring-white/10 px-4 py-3 flex items-center gap-3" data-testid={`brand-tag-${i}`}>
              <Icon className="size-4 text-ice-400" /><span className="text-sm">{label}</span>
            </div>
          ))}
        </div>

        <div className="mt-10 rounded-2xl bg-gradient-to-br from-ice-400/10 to-transparent ring-1 ring-ice-400/30 p-6 md:p-8 flex flex-col md:flex-row items-center justify-between gap-4" data-testid="brand-callout">
          <div>
            <div className="font-display font-bold text-lg">Don&apos;t see your brand?</div>
            <p className="text-silver-300 text-sm mt-1">Our technicians have experience working with nearly every major HVAC manufacturer.</p>
          </div>
          <a href={`tel:${COMPANY.phoneTel}`} onClick={onCallClick} className="btn-primary px-5 py-3 rounded-full text-sm flex items-center gap-2" data-testid="brand-call">
            <Phone className="size-4" /> {COMPANY.phone}
          </a>
        </div>
      </div>
    </section>
  );
}
